import { ObservableMap } from 'mobx';
import type ComplianceConfiguration from 'owa-service/lib/contract/ComplianceConfiguration';
import type MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';

export default function getDefaultProtectionStore() {
    return {
        clpLabels: [],
        learnMoreUrl: '',
        hasMandatoryLabel: false,
        rmsTemplates: new ObservableMap<string, ComplianceConfiguration>(),
        messageClassifications: new ObservableMap<string, MessageClassificationType>(),
    };
}
